import * as React from "react"
export function OfficeLogo(props: any) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1167 1405" {...props}>
      <path
        fill="#ec3900"
        d="M405 145.5C206.7 218.9 37 281.7 27.8 285.1L11 291.2v427.5c0 406.7.1 427.5 1.8 426.8.9-.3 60.1-26.1 131.4-57.3l129.8-56.7V694.3c0-185.4.3-337.4.8-337.6.4-.3 110-26 243.7-57.1C652.2 268.4 763 242.5 764.8 242l3.2-.8v997.1l-3.7-.6c-10.2-1.6-744.9-89.7-746.1-89.5-1.4.3 745.7 269.1 749.3 269.6 1.2.2 94.1-27.4 206.4-61.2 112.3-33.9 204.4-61.6 204.7-61.6.2 0 .3-259.3.2-576.2l-.3-576.1-204-65.3C862.3 41.4 769.4 12.1 768 12.1c-1.4.1-164.7 60.1-363 133.4z"
      />
    </svg>
  )
}
